/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'space-directory.filters.personal.v2': 'Pessoal',
  'space-directory.filters.starred': 'Marcado com estrela',
};
